import {apiUrl} from "../urls";
import {useEffect} from "react";
import {findInCache, updateCache} from "../helpers/cacheUtils";
import {clone} from "../../utils/misc/helpers";
import usePost from "../axios/usePost";
import {Booking} from "../../model/Booking";


const useCancelBooking = (myBookings: Booking[], cruiseBookings: Booking[], setMyBookings: Function, setCruiseBookings: Function) => {
  const {
    data,
    setData,
    loading: cancelBookingLoading,
    postData: cancelBooking,
  } = usePost(apiUrl.bookings + "/cancel/");

  useEffect(() => {
    if (data) {
      const postResponse = data as Booking;
      if (findInCache(postResponse.id, myBookings)){
        const cacheClone = clone(myBookings);
        updateCache([postResponse], cacheClone);
        setMyBookings(cacheClone);
      }
      if (findInCache(postResponse.id, cruiseBookings)){
        const cacheClone = clone(cruiseBookings);
        updateCache([postResponse], cacheClone);
        setCruiseBookings(cacheClone);
      }
      setData(null);
    }
  }, [data, myBookings, setMyBookings, cruiseBookings, setCruiseBookings, setData])

  return {cancelBookingLoading, cancelBooking}
}

export default useCancelBooking;